import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import Metrics from '@spotahome/soyuz-tracking';

import { getBudgetValue } from '@spotahome/marketplace-common/src/utils/filters';

import { requestUnitPrices } from '../../utils/priceFilter';

import FilterGroup from '../FilterGroup';
import FormSlider from '../FormSlider';

const FILTER_NAME = 'budget';

const PriceSliderFilter = ({
  budget,
  maxPriceInCity,
  updateFiltersWith,
  disablePrice,
  currencyIsoCode,
  showLabel,
  histogramMaxHeight,
  cityId,
  adaptedFilters
}) => {
  const [unitPrices, setUnitPrices] = useState([]);

  const receivedBudget = budget;
  const splittedBudget = receivedBudget && receivedBudget.split('-');
  const budgetMin = parseInt(splittedBudget[0], 10) || 0;
  const budgetMax = parseInt(splittedBudget[1], 10) || '';

  useEffect(() => {
    const updateUnitPrices = async () => {
      const newUnitPrices = await requestUnitPrices({
        cityId,
        adaptedFilters,
        maxPriceInCity
      });
      setUnitPrices(newUnitPrices);
    };
    updateUnitPrices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adaptedFilters]);

  const sendPriceChangeEvent = newBudget =>
    newBudget.includes('-')
      ? Metrics.ga.sendEvent(
          'Search',
          'PriceSliderFilter',
          'range-price-update'
        )
      : Metrics.ga.sendEvent('Search', 'PriceSliderFilter', 'min-price-update');

  const updateBudget = ({ minPrice, maxPrice }) => {
    const budgetValue = getBudgetValue({
      minBudget: minPrice || budgetMin,
      maxBudget: maxPrice || budgetMax,
      maxPrice: maxPriceInCity
    });

    sendPriceChangeEvent(budgetValue);
    updateFiltersWith({ [FILTER_NAME]: budgetValue });
  };

  const handleOnSliderChange = event =>
    updateBudget({
      minPrice: event.sliderFrom,
      maxPrice: event.sliderTo
    });

  const renderSlider = () => (
    <>
      {disablePrice && <div className="filter-group--price-range-blocker" />}
      <FormSlider
        histogramMaxHeight={histogramMaxHeight}
        onChange={handleOnSliderChange}
        sliderFrom={budgetMin}
        sliderTo={budgetMax || maxPriceInCity}
        currencyIsoCode={currencyIsoCode}
        unitPrices={unitPrices}
        maxPrice={maxPriceInCity}
        trackingPrefix="ga-search-form-price-slider"
      />
    </>
  );

  return showLabel ? (
    <FilterGroup
      classModifier="price-range"
      label={trans('search.filter.price.range')}
    >
      {renderSlider()}
    </FilterGroup>
  ) : (
    renderSlider()
  );
};

PriceSliderFilter.propTypes = {
  budget: PropTypes.string,
  updateFiltersWith: PropTypes.func.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  maxPriceInCity: PropTypes.number.isRequired,
  disablePrice: PropTypes.bool,
  showLabel: PropTypes.bool,
  histogramMaxHeight: PropTypes.number,
  adaptedFilters: PropTypes.shape({}).isRequired,
  cityId: PropTypes.string.isRequired
};

PriceSliderFilter.defaultProps = {
  budget: '',
  disablePrice: false,
  showLabel: true,
  histogramMaxHeight: 60
};

export default PriceSliderFilter;
